import React from 'react'
import CardUI from '../../../widgets/layout/CardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import CustomerInvoicesNavUI from './CustomerInvoicesNavUI'
import RfMonthlyLimitAddModalSF from './RfMonthlyLimitAddModalSF'
// import './RfMonthlyLimitPage.css'

const RfMonthlyLimitPageUI = ({ context, account, monthlyAccountSummaryList, onRefreshClick,
  monthlyLimitAdded, onAddMonthlyLimitClick, onAddMonthlyLimitCancel, onDeleteMonthlyLimitClick
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_rf' backLink='/su/accounts'
    headerText={account && account.accountName} centered={!account || !monthlyAccountSummaryList}
    account={account} page='rf'
  >
    {
      (!account || !monthlyAccountSummaryList) &&
      <SpinnerComponentUI />
    }
    {
      account && monthlyAccountSummaryList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <div className='g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <IconButtonUI icon='icon-plus' onClick={onAddMonthlyLimitClick} />
              <span className='g_m_left_100 g_large'><b>Receivable Financing</b></span>
            </div>
          }
          right={<span />}
        />
        <CustomerInvoicesNavUI context={context} account={account} page='limit' />

        <MonthlyLimitTableUI context={context} account={account} monthlyAccountSummaryList={monthlyAccountSummaryList}
          onDeleteMonthlyLimitClick={onDeleteMonthlyLimitClick} />
      </div>
    }

    <RfMonthlyLimitAddModalSF context={context} account={account} onRefreshClick={onRefreshClick}
      createMode={monthlyLimitAdded} onCancelClick={onAddMonthlyLimitCancel} />

  </SuperUserAccountPageUI>

const MonthlyLimitTableUI = ({ context, account, monthlyAccountSummaryList, onDeleteMonthlyLimitClick }) =>
  <CardUI>
    <table>
      <thead>
        <tr >
          <th>Month</th>
          <th>Limit</th>
        </tr>
      </thead>
      <tbody>
        {
          monthlyAccountSummaryList.map((limit, i) =>
            <tr key={i}>
              <td>{limit.yearMonth}</td>
              <td className='g_text_right'>{limit.receivableFinancingAmountF4}</td>
              <td><span className='icon icon-trash-o' onClick={onDeleteMonthlyLimitClick} data-year-month={limit.yearMonth} /></td>
            </tr>
          )
        }
      </tbody>
    </table>
  </CardUI>

export default RfMonthlyLimitPageUI
